import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import {
  Container,
  Segment,
  Divider,
  Form,
  Icon,
  Button,
  Header,
  Loader,
  Responsive,
} from "semantic-ui-react";
import TestataPagina from "../common/TestataPagina";
import TestoPrivacy from "../common/TestoPrivacy";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import * as emailUtils from "../../utils/emailUtils";
import * as checkInApi from "../../api/checkinApi";
import { validaCodiceFiscale } from "../../utils/cfUtils";
import InfoWeb from "../common/InfoWeb";
import FormClienteNew from "../common/FormClienteNew";
import {
  hasThreeConsecutiveChars,
  isValidEuropeanZipCode,
} from "../../utils/strUtils";

const CheckInMain = ({
  datiScuola,
  codScuola,
  appData,
  lang,
  ...props
}) => {
  const history = useHistory();
  const location = useLocation();
  const [listaNazioni, setListaNazioni] = useState([]);
  const [listaNazioniDial, setListaNazioniDial] = useState([]);
  const [trFinalyzing, setTrFinalyzing] = useState(false);
  const [privacy, setPrivacy] = useState(false);
  const [privacy2, setPrivacy2] = useState(false);
  const [privacy3, setPrivacy3] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showPrivacy2, setShowPrivacy2] = useState(false);
  const [showPrivacy3, setShowPrivacy3] = useState(false);
  const [listaLivelli, setListaLivelli] = useState([]);
  const [listaAnni, setListaAnni] = useState([]);
  const [listaLingue, setListaLingue] = useState([]);
  const [listaProvince, setListaProvince] = useState([]);
  const [listaHotels, setListaHotels] = useState([]);
  const [listaSesso, setListaSesso] = useState([]);
  const [numAllievi, setNumAllievi] = useState(3);
  const [datiCliente, setDatiCliente] = useState(() => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      return {
        nome: "TEST NOME",
        cognome: "TEST COGNOME",
        nazione: "IT",
        prefisso: "+39",
        citta: "TEST CITTA",
        provincia: "TN",
        cap: "38037",
        indirizzo: "VIA TEST, 28",
        telefono: "300000000",
        email: "juricapovilla@gmail.com",
        cf: "",
        dataNascita: "",
        luogoNascita: "",
        tipo: "P",
      };
    } else {
      return {
        nome: "",
        cognome: "",
        nazione: (appData.lang?.toLowerCase() ?? "it") === "it" ? "IT" : "",
        prefisso: (appData.lang?.toLowerCase() ?? "it") === "it" ? "+39" : "",
        citta: "",
        provincia: "",
        cap: "",
        indirizzo: "",
        telefono: "",
        email: "",
        cf: "",
        dataNascita: "",
        luogoNascita: "",
        tipo: "P",
      };
    }
  });
  const [datiAllievi, setDatiAllievi] = useState(
    () => Array.from({ length: 20 }, () => ({ nome: "", cognome: "", livello: -1, anno: -1, sesso: "" }))
  );
  const [errorsAllievi, setErrorsAllievi] = useState(() => Array.from({ length: 20 }, () => ({})));
  const [errors, setErrors] = useState({
    codice: false,
    nome: false,
    cognome: false,
    nazione: false,
    citta: false,
    cap: false,
    indirizzo: false,
    provincia: false,
    email: false,
    telefono: false,
    causale: false,
    importo: false,
    privacy: false,
    condizioniVendita: false,
    cf: false,
    luogoNascita: false,
    dataNascita: false,
    annoNascita: false,
  });
  const [idStorico, setIdStorico] = useState(null);
  const [linkError, setLinkError] = useState(false);
  const [idRichiesta, setIdRichiesta] = useState(null);
  // Add loadingCheckInData state
  const [loadingCheckInData, setLoadingCheckInData] = useState(false);
  // Add state for tracking if account holder is also a student
  const [intestatarioAllievo, setIntestatarioAllievo] = useState(false);

  //////////////////////////////////////////
  //REFS
  const userDataRef = useRef();

  const { t, i18n } = useTranslation([datiScuola.customTranslationNamespace]);
  // useEffect(() => {
  //   i18n.emit("languageChanged");
  // }, [datiScuola.customTranslationNamespace]);
  useEffect(() => {
    if (appData.hasOwnProperty("lang")) {
      i18n.changeLanguage(appData.lang.toLowerCase());
    }
  }, [appData.lang]);

  // Initialize listaSesso after translation is ready
  useEffect(() => {
    setListaSesso([
      { key: "", value: "", text: t("Seleziona") },
      { key: "M", value: "M", text: t("Maschio") },
      { key: "F", value: "F", text: t("Femmina") }
    ]);
  }, [t]);


  // New useEffect to extract and handle GUID from URL
  useEffect(() => {
    const extractAndProcessGuid = async () => {
      // Use URLSearchParams to get query parameters
      const queryParams = new URLSearchParams(location.search);
      const codCheckin = queryParams.get('codcheckin');

      // Show loader while fetching
      setLoadingCheckInData(true);
      await fetchCheckInData(codCheckin);
      setLoadingCheckInData(false);
    };

    if (appData.slug?.toUpperCase() !== codScuola?.toUpperCase())
      return;

    extractAndProcessGuid();

  }, [location.search, datiScuola.id]);

  useEffect(() => {
    if (datiScuola.richiestaHotel && datiScuola.hotels.length > 0) {
      setListaHotels([
        { key: "", value: "", text: t("Seleziona_Hotel") },
        { key: "_X", value: "_X", text: t("No_Hotel") },
        ...datiScuola.hotels.map((h) => {
          return { key: h, value: h, text: h };
        }),
      ]);
    }

    if (datiScuola.hasOwnProperty("listaNazioni") && datiScuola !== undefined) {
      setListaNazioni(
        datiScuola.listaNazioni.map((n) => {
          return { key: n.iso, value: n.iso, text: n.nazione };
        })
      );

      setListaProvince(
        datiScuola.listaProvince.map((n) => {
          return { key: n.sigla, value: n.sigla, text: n.nome };
        })
      );

      setListaLingue(
        datiScuola.lingue.map((n) => {
          return {
            key: n.idskiwork,
            value: n.codiceIso,
            text: n.linguaParlata,
          };
        })
      );

      setListaNazioniDial(
        [...datiScuola.listaNazioni]
          .sort((a, b) => {
            const nameA = a.iso.toUpperCase(); // ignore upper and lowercase
            const nameB = b.iso.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            // names must be equal
            return 0;
          })
          .filter((n) => {
            return n.dialCode?.length >= 2;
          })
          .map((n) => {
            return {
              key: n.iso,
              value: n.dialCode,
              text: n.iso + " " + n.dialCode,
              flag: n.iso.toLowerCase(),
            };
          })
      );

      const livelliTmp = datiScuola.tLivelli.map((n) => {
        return { key: n.idLivelloIso, value: n.idLivelloIso, text: n.livello };
      });
      livelliTmp.push({ key: -1, value: -1, text: "N/D" });
      setListaLivelli(livelliTmp);

      const currentYear = new Date().getFullYear();
      let listaAnniTmp = [{ key: -1, value: -1, text: "" }];
      listaAnniTmp = listaAnniTmp.concat(
        [...Array(100).keys()]
          .filter((x) => currentYear - x < currentYear - 3)
          .map((x, i) => {
            return {
              key: currentYear - i,
              value: currentYear - i,
              text: currentYear - i,
            };
          })
      );

      setListaAnni(listaAnniTmp);
    }
  }, [datiScuola]);

  // New function to fetch data from API
  const fetchCheckInData = async (guid) => {
    if (!guid || datiScuola?.id === undefined) {
      setLoadingCheckInData(false); // Ensure loader is hidden if no guid
      return;
    }

    try {
      const response = await checkInApi.GetCheckInData(guid, datiScuola.id);

      if (response && response.ok) {
        const data = await response.json();
        setIdStorico(data.idStorico);
        populateFormWithData(data);
        setLinkError(false);
      } else {
        console.error("Failed to fetch check-in data");
        setLinkError(true);
      }
    } catch (error) {
      console.error("Error fetching check-in data:", error);
      setLinkError(true);
    }
  };

  // New function to sort allievi data
  const sortAllieviData = (allieviData) => {
    const sorted = [...allieviData];
    sorted.sort((a, b) => {
      // Skip sorting for entries with both nome and cognome empty
      const aIsEmpty = (!a.nome || a.nome.trim() === "") && (!a.cognome || a.cognome.trim() === "");
      const bIsEmpty = (!b.nome || b.nome.trim() === "") && (!b.cognome || b.cognome.trim() === "");

      // If both are empty, maintain original order
      if (aIsEmpty && bIsEmpty) return 0;
      // Empty entries go to the end
      if (aIsEmpty) return 1;
      if (bIsEmpty) return -1;

      const nomeA = (a.nome || "").toLowerCase();
      const nomeB = (b.nome || "").toLowerCase();
      const cognomeA = (a.cognome || "").toLowerCase();
      const cognomeB = (b.cognome || "").toLowerCase();

      if (nomeA < nomeB) return -1;
      if (nomeA > nomeB) return 1;
      if (cognomeA < cognomeB) return -1;
      if (cognomeA > cognomeB) return 1;
      return 0;
    });
    return sorted;
  };

  // New function to populate form fields with retrieved data
  const populateFormWithData = (data) => {
    // Update cliente data
    if (data) {
      setDatiCliente({
        ...datiCliente,
        ...data,
      });

      setIdRichiesta(data.idRichiesta);

      // Check if account holder data includes student fields
      if ((data.annoNascita !== undefined && data.annoNascita > 0) || (data.livello !== undefined && data.livello > 0)) {
        setIntestatarioAllievo(true);
      }
    }

    // Update allievi if present
    if (data.datiAllievi && Array.isArray(data.datiAllievi)) {
      const updatedAllievi = [...datiAllievi];

      data.datiAllievi.forEach((allievo, index) => {
        if (index < updatedAllievi.length) {
          updatedAllievi[index] = {
            ...updatedAllievi[index],
            idStorico: allievo.idStorico || null,
            nome: allievo.nome || "",
            cognome: allievo.cognome || "",
            livello: allievo.livello || -1,
            anno: allievo.anno || -1,
            sesso: allievo.sesso || ""
          };
        }
      });

      // Sort the allievi data only once after fetching
      const sortedAllievi = sortAllieviData(updatedAllievi);
      setDatiAllievi(sortedAllievi);
      setNumAllievi(Math.max(numAllievi, data.datiAllievi.length));
    }
  };


  function checkDati() {
    let checkOk = true;
    var newErrors = { ...errors };

    if (datiCliente.nome.length < 2 || datiCliente.nome > 50) {
      newErrors.nome = true;
      checkOk = false;
    }
    if (datiCliente.cognome.length < 2 || datiCliente.cognome > 50) {
      newErrors.cognome = true;
      checkOk = false;
    }
    if (datiCliente.nazione.length !== 2) {
      newErrors.nazione = true;
      checkOk = false;
    }
    if (
      datiCliente.citta.length < 3 ||
      datiCliente.citta.length > 50 ||
      hasThreeConsecutiveChars(datiCliente.citta)
    ) {
      newErrors.citta = true;
      checkOk = false;
    }

    //INDIRIZZO
    if (
      datiCliente.indirizzo.length < 5 ||
      datiCliente.indirizzo.length > 50 ||
      hasThreeConsecutiveChars(datiCliente.indirizzo)
    ) {
      newErrors.indirizzo = true;
      checkOk = false;
    }

    //CAP
    if (!isValidEuropeanZipCode(datiCliente.cap, datiCliente.nazione)) {
      newErrors.cap = true;
      checkOk = false;
    } else {
      newErrors.cap = false;
    }

    //CONTROLLI PER CLIENTI ITALIANI
    if (datiCliente.nazione === "IT") {
      //PROVINCIA
      if (datiCliente.provincia === null) datiCliente.provincia = "";
      if (datiCliente.provincia.length !== 2) {
        newErrors.provincia = true;
        datiCliente.provincia = "";
        checkOk = false;
      }

      //CF
      newErrors.cf = false;
      if (
        !validaCodiceFiscale(
          datiCliente.cf,
          datiCliente.nome,
          datiCliente.cognome
        )
      ) {
        newErrors.cf = true;
        checkOk = false;
      }
    } else {
      datiCliente.cf = "";
      datiCliente.provincia = "";
    }

    //AZIENDE
    if (datiCliente.tipo === "A") {
      //verifico la validità della partita iva (11 caratteri)
      const regexPIVA = /^\d{11}$/;
      if (!regexPIVA.test(datiCliente.cf)) {
        newErrors.cf = true;
        checkOk = false;
      }

      //verifico la validità del codice univoco se Italiano
      if (datiCliente.nazione === "IT") {
        const regexCodUnivoco = /^[a-zA-Z0-9]{7}$/;
        if (!regexCodUnivoco.test(datiCliente.codUnivoco)) {
          newErrors.codUnivoco = true;
          checkOk = false;
        }
      } else {
        datiCliente.codUnivoco = "";
      }
    }

    //EMAIL
    if (
      datiCliente.email.length < 2 ||
      datiCliente.email.length > 50 ||
      !emailUtils.ValidateEmail(datiCliente.email)
    ) {
      newErrors.email = true;
      checkOk = false;
    }

    //TELEFONO
    if (datiCliente.telefono.length < 5 || datiCliente.telefono.length > 15) {
      newErrors.telefono = true;
      checkOk = false;
    }

    //INTESTATARIO ALLIEVO - check student fields if checkbox is checked
    if (intestatarioAllievo) {
      if (!datiCliente.annoNascita || datiCliente.annoNascita === -1) {
        newErrors.annoNascita = true;
        checkOk = false;
      }
      if (!datiCliente.sesso || datiCliente.sesso === "") {
        newErrors.sesso = true;
        checkOk = false;
      }
    }

    //VALIDAZIONE ALLIEVI - check mandatory fields for students with name and surname
    const newErrorsAllievi = [...errorsAllievi];
    for (let i = 0; i < datiAllievi.length; i++) {
      const allievo = datiAllievi[i];
      if (allievo.nome.trim() !== "" || allievo.cognome.trim() !== "") {
        // If student has name or surname, all fields become mandatory
        if (allievo.nome.trim() === "") {
          newErrorsAllievi[i] = { ...newErrorsAllievi[i], nome: true };
          checkOk = false;
        }
        if (allievo.cognome.trim() === "") {
          newErrorsAllievi[i] = { ...newErrorsAllievi[i], cognome: true };
          checkOk = false;
        }
        if (!allievo.anno || allievo.anno === -1) {
          newErrorsAllievi[i] = { ...newErrorsAllievi[i], anno: true };
          checkOk = false;
        }
        if (!allievo.sesso || allievo.sesso === "") {
          newErrorsAllievi[i] = { ...newErrorsAllievi[i], sesso: true };
          checkOk = false;
        }
      }
    }
    setErrorsAllievi(newErrorsAllievi);

    //PRIVACY
    if (privacy === false) {
      newErrors.privacy = true;
      checkOk = false;
    }

    //RICHIESTA HOTEL
    if (datiScuola.richiestaHotel && datiScuola.hotels.length > 0) {
      if (datiCliente.hotel === "") {
        newErrors.hotel = true;
        checkOk = false;
      }
    }

    setErrors(newErrors);
    return checkOk;
  }

  //Helpers Functions
  function handleFieldChange(ev, data) {
    if (data.name === "cap") {
      if (data.value.length > 6) data.value = data.value.substring(0, 6);
    }

    if (data.name === "telefono") {
      const re = /^[0-9\b]+$/;
      if (data.value !== "" && !re.test(data.value)) {
        data.value = datiCliente.telefono;
      }
    }
    if (data.name === "nazione") {
      const nation = listaNazioniDial.find((x) => x.key === data.value);
      datiCliente.prefisso = nation.value;
    }

    let datiTmp = { ...datiCliente };
    datiTmp[data.name] = data.value;
    setErrors({ ...errors, [data.name]: false });
    setDatiCliente(datiTmp);
  }

  const handleAllievoFieldChange = (data, idx) => {
    let datiTmp = JSON.parse(JSON.stringify(datiAllievi)); // Deep copy
    if (data.name === "nome") {
      datiTmp[idx].nome = data.value;
    }
    if (data.name === "cognome") {
      datiTmp[idx].cognome = data.value;
    }

    if (data.name === "livello") {
      datiTmp[idx].livello = data.value;
    }

    if (data.name === "annoNascita") {
      datiTmp[idx].anno = data.value;
    }

    if (data.name === "sesso") {
      datiTmp[idx].sesso = data.value;
    }
    setDatiAllievi(datiTmp);

    const errorsTmp = [...errorsAllievi];
    if (data.name === "annoNascita") {
      errorsTmp[idx] = { ...errorsAllievi[idx], anno: false };
    } else {
      errorsTmp[idx] = { ...errorsAllievi[idx], [data.name]: false };
    }

    setErrorsAllievi(errorsTmp);
  };

  function handlePrivacyChange(ev, data) {
    setPrivacy(data.checked);
    setErrors({ ...errors, privacy: !data.checked });
  }

  function handlePrivacy2Change(ev, data) {
    setDatiCliente({ ...datiCliente, privacy2: data.checked });
    setPrivacy2(data.checked);
  }
  function handlePrivacy3Change(ev, data) {
    setDatiCliente({ ...datiCliente, privacy3: data.checked });
    setPrivacy3(data.checked);
  }

  function handleIntestatarioAllievoChange(ev, data) {
    setIntestatarioAllievo(data.checked);

    // If unchecked, clear the student-related fields for the account holder
    // BUT only if there's no valid historical data (idStorico)
    if (!data.checked && (!idStorico || idStorico <= 0)) {
      setDatiCliente({
        ...datiCliente,
        livello: -1,
        annoNascita: -1,
        sesso: ""
      });
    }
  }

  // New function to handle intestatario student field changes
  function handleIntestatarioStudentFieldChange(ev, data) {
    let datiTmp = { ...datiCliente };
    datiTmp[data.name] = data.value;
    setErrors({ ...errors, [data.name]: false });
    setDatiCliente(datiTmp);
  }

  async function handleEffettuaCheckin(ev, data) {
    if (!checkDati()) {
      userDataRef.current.scrollIntoView(true, {
        behavior: "smooth",
        block: "start",
      });
      return;
    }
    setTrFinalyzing(true);

    //correggo i livelli
    for (let i = 0; i < datiAllievi.length; i++) {
      if (parseInt(datiAllievi[i].livello) !== -1) {
        if (datiAllievi[i].cognome !== "") {
          datiAllievi[i].livello = datiScuola.tLivelli.filter(
            (x) => x.idLivelloIso === parseInt(datiAllievi[i].livello)
          )[0].idLivelloIso;
        }
      }
    }

    datiCliente.allievi = datiAllievi.filter(
      (x) => x.nome !== "" && x.cognome !== ""
    );

    var result = await checkInApi.CheckIn({
      ...datiCliente,
      idScuola: datiScuola.id,
      codiceScuola: codScuola,
      idStorico,
    }, idRichiesta);

    if (result === null) {
      alert("problemi nell'esecuzione del check-in, riprovare più tardi");
      setTrFinalyzing(false);
      return;
    }

    if (result.ok === false) {
      alert("problemi nell'esecuzione del check-in, riprovare più tardi");
      setTrFinalyzing(false);
      return;
    }

    //console.log(await result.json());
    history.push(`/${appData.lang}/${appData.slug}/Checkin/Ok`);

    setTrFinalyzing(false);
  }

  if (props.loading || datiScuola === undefined || trFinalyzing || loadingCheckInData) {
    return <Loader size="huge" active />;
  } else {
    return (
      <Container>
        <div className="head-offset"></div>
        <TestataPagina
          titolo="ONLINE CHECK-IN"
          icon="address book"
        />
        <Segment
          className="padding_5_lr contenitore-grande"
          style={{ marginBottom: "30px" }}
        >
          <div ref={userDataRef}></div>

          {linkError ? (
            <div>
              <Header as="h3" color="red" textAlign="center">
                <Icon name="warning sign" />
                <Header.Content>
                  {t("Link_non_più_valido")}
                </Header.Content>
              </Header>
              <p style={{ textAlign: "center" }}>
                {t("Link_non_più_valido_desc")}
                {/* Il link utilizzato non è più valido o è scaduto. Si prega di richiedere un nuovo link per effettuare il check-in. */}
              </p>
            </div>
          ) : (
            <>
              <Header as="h3" className="skiwork-titolo">
                <Header.Content className="scelta-data">
                  {t("DATI_CLIENTE_INTESTATARIO")}
                </Header.Content>
              </Header>

              <FormClienteNew
                datiCliente={datiCliente}
                datiScuola={datiScuola}
                handleFieldChange={handleFieldChange}
                listaNazioni={listaNazioni}
                listaNazioniDial={listaNazioniDial}
                listaProvince={listaProvince}
                listaHotel={listaHotels}
                listaLingue={listaLingue}
                errors={errors}
                t={t}
                fatturazione={datiScuola.fatturazione}
              />

              <Form style={{ marginTop: "20px", marginBottom: "20px" }}>
                <Form.Checkbox
                  label={t("Partecipero_lezioni")}
                  checked={intestatarioAllievo}
                  onChange={handleIntestatarioAllievoChange}
                />
              </Form>

              {intestatarioAllievo && (
                <>
                  <Form style={{ marginBottom: "20px" }}>
                    <Form.Group>
                      <Form.Select
                        label={t("anno_nascita")}
                        placeholder={t("anno_nascita")}
                        fluid
                        name="annoNascita"
                        options={listaAnni}
                        onChange={handleIntestatarioStudentFieldChange}
                        width={5}
                        value={datiCliente.annoNascita || -1}
                        error={errors.annoNascita ? "!!!" : null}
                      />
                      <Form.Select
                        label={t("livello")}
                        placeholder={t("livello")}
                        fluid
                        name="livello"
                        options={listaLivelli}
                        onChange={handleIntestatarioStudentFieldChange}
                        width={6}
                        value={datiCliente.livello || -1}
                        error={errors.livello ? "!!!" : null}
                      />
                      <Form.Select
                        label={t("Sesso")}
                        placeholder={t("Sesso")}
                        fluid
                        name="sesso"
                        options={listaSesso}
                        onChange={handleIntestatarioStudentFieldChange}
                        width={5}
                        value={datiCliente.sesso || ""}
                        error={errors.sesso ? "!!!" : null}
                      />
                    </Form.Group>
                  </Form>
                </>
              )}
              <Divider />
              <Header as="h3" className="skiwork-titolo">
                <Header.Content className="scelta-data">
                  {intestatarioAllievo ? t("DATI_ALTRI_ALLIEVI") : t("DATI_ALLIEVI")}
                </Header.Content>
              </Header>
              <Form>
                {datiAllievi.slice(0, numAllievi).map((allievoDisplayData, originalIndex) => (
                  <React.Fragment key={originalIndex}>
                    <Responsive maxWidth={768}>
                      <Divider />
                      <div style={{ textAlign: "center" }}>Allievo {originalIndex + 1}</div>
                    </Responsive>
                    <Form.Group>
                      <Form.Input
                        label={t("nome")}
                        placeholder={t("nome")}
                        fluid
                        name="nome"
                        onChange={(ev, data) => handleAllievoFieldChange(data, originalIndex)}
                        width={8}
                        value={allievoDisplayData.nome}
                        error={
                          errorsAllievi[originalIndex]?.nome
                            ? { content: t("nome_error") }
                            : null
                        }
                      />
                      <Form.Input
                        label={t("cognome")}
                        placeholder={t("cognome")}
                        fluid
                        name="cognome"
                        onChange={(ev, data) => handleAllievoFieldChange(data, originalIndex)}
                        width={8}
                        value={allievoDisplayData.cognome}
                        error={
                          errorsAllievi[originalIndex]?.cognome
                            ? { content: t("cognome_error") }
                            : null
                        }
                      />
                      <Form.Select
                        label={t("anno_nascita")}
                        placeholder={t("anno_nascita")}
                        fluid
                        name="annoNascita"
                        options={listaAnni}
                        onChange={(ev, data) => handleAllievoFieldChange(data, originalIndex)}
                        width={8}
                        value={allievoDisplayData.anno}
                        error={errorsAllievi[originalIndex]?.anno ? "!!!" : null}
                      />
                      <Form.Select
                        label={t("livello")}
                        placeholder={t("livello")}
                        fluid
                        name="livello"
                        options={listaLivelli}
                        onChange={(ev, data) => handleAllievoFieldChange(data, originalIndex)}
                        width={8}
                        value={allievoDisplayData.livello}
                        error={errorsAllievi[originalIndex]?.livello ? "!!!" : null}
                      />
                      <Form.Select
                        label={t("Sesso")}
                        placeholder={t("Sesso")}
                        fluid
                        name="sesso"
                        options={listaSesso}
                        onChange={(ev, data) => handleAllievoFieldChange(data, originalIndex)}
                        width={8}
                        value={allievoDisplayData.sesso}
                        error={errorsAllievi[originalIndex]?.sesso ? "!!!" : null}
                      />
                    </Form.Group>
                    <Responsive
                      maxWidth={768}
                      style={{ marginBottom: "14px" }}
                    ></Responsive>
                  </React.Fragment>
                ))}
                {numAllievi < 20 && (
                  <div style={{ width: "100%", textAlign: "right" }}>
                    <Button
                      primary
                      onClick={() => {
                        setNumAllievi(numAllievi + 1);
                      }}
                    >
                      <Icon name="plus"></Icon>
                      Altro allievo
                    </Button>
                  </div>
                )}
              </Form>
              <Form>
                <Divider />
                <div
                  style={{ cursor: "pointer", marginBottom: "14px" }}
                  onClick={() => {
                    setShowPrivacy(true);
                  }}
                >
                  <a href>
                    {t("informativa")} <Icon name="external"></Icon>
                  </a>
                </div>
                <Form.Checkbox
                  label={t("acconsento_privacy")}
                  checked={privacy}
                  onChange={handlePrivacyChange}
                  error={
                    errors.privacy
                      ? {
                        content: t("necessario_accettare_privacy"),
                        pointing: "left",
                      }
                      : null
                  }
                ></Form.Checkbox>
                {datiScuola.richiediPrivacy2 && (
                  <>
                    <Form.Checkbox
                      label={datiScuola.titoloPrivacy2}
                      checked={privacy2}
                      name="privacy2"
                      onChange={handlePrivacy2Change}
                    ></Form.Checkbox>
                    {(datiScuola.testoPrivacy2?.length ?? 0) > 0 && (
                      <p
                        style={{
                          marginLeft: "32px",
                          marginTop: "-14px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setShowPrivacy2(true);
                        }}
                      >
                        <a href>
                          Maggiori informazioni <Icon name="external"></Icon>
                        </a>
                      </p>
                    )}
                  </>
                )}
                {datiScuola.richiediPrivacy3 && (
                  <>
                    <Form.Checkbox
                      label={datiScuola.titoloPrivacy3}
                      checked={privacy3}
                      name="privacy3"
                      onChange={handlePrivacy3Change}
                    ></Form.Checkbox>
                    {(datiScuola.testoPrivacy3?.length ?? 0) > 0 && (
                      <p
                        style={{
                          marginLeft: "32px",
                          marginTop: "-14px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setShowPrivacy3(true);
                        }}
                      >
                        <a href>
                          Maggiori informazioni <Icon name="external"></Icon>
                        </a>
                      </p>
                    )}
                  </>
                )}
                {datiScuola.infoWeb !== undefined && (
                  <div
                    style={{
                      marginTop: "2em",
                    }}
                  >
                    <InfoWeb
                      testi={datiScuola.infoWeb.filter((x) => x.sezione === 2)}
                      sezione={2}
                    />
                  </div>
                )}

                <p style={{ textAlign: "center" }}>
                  <Button size="huge" primary onClick={handleEffettuaCheckin}>
                    CHECK-IN
                  </Button>
                </p>
              </Form>
            </>
          )}

          <TestoPrivacy
            isOpen={showPrivacy}
            onClose={() => {
              setShowPrivacy(false);
            }}
            t={t}
          />
          <TestoPrivacy
            isOpen={showPrivacy2}
            onClose={() => {
              setShowPrivacy2(false);
            }}
            t={t}
            numRichiesta={2}
          />
          <TestoPrivacy
            isOpen={showPrivacy3}
            onClose={() => {
              setShowPrivacy3(false);
            }}
            t={t}
            numRichiesta={3}
          />
        </Segment>
      </Container>
    );
  }
};

function mapStateToProps(state, ownProps) {
  return {
    codScuola: ownProps.match.params.slug,
    lang: ownProps.match.params.lang,
    appData: state.appReducer,
    datiScuola: state.scuolaReducer,
    loading: state.apiCallsInProgress > 0,
  };
}

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckInMain);
